const renewCertificate = {
  default: {
    title: 'Renovar certificado do documento',
    description: 'Selecione um documento assinado pela Clicksign em .PDF.',
  },
  finished: {
    title: 'Certificado renovado!',
    description: 'Baixe o documento com o certificado renovado.',
    button: 'Baixar documento',
  },
  with_tsa: {
    title: 'O documento possui carimbo de tempo ativo',
    description: 'Não ha necessidade de re-assinatura',
  },
};

export default renewCertificate;
